module.exports = __webpack_public_path__ + "static/media/tim.f1d69910.png";